import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ReportModel } from '@core/models/outros/report.model';

@Component({
  selector: 'app-print-report-txt',
  templateUrl: './print-report-txt.component.html',
  styleUrls: ['./print-report-txt.component.scss']
})
export class PrintReportTxtComponent implements OnInit, AfterViewInit {

  @Input() set reportData(value) {
    if (value !== this.report) {
      this.report = value;
    }
  }
  report: ReportModel;
  head: string[] = new Array<string>()
  rows: string[][] = new Array<Array<string>>()

  constructor(
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.setHeaderSize()
    this.setRowsSize()
    this._cdr.detectChanges()
  }

  setHeaderSize() {
    let i = 0;
    this.report.cols.forEach(x => {
      let item = this._getSizeItem(this.report.cols[i].reportTxtCellWidth, x.name)
      this.head.push(item);
      i++;
    })
  }

  setRowsSize() {
    this.report.rows.forEach(
      (eventItem: []) => {
        let items: string[] = new Array<string>();
        let i = 0;
        eventItem.forEach((x: string) => {
          x = x + '';
          let item = this._getSizeItem(this.report.cols[i].reportTxtCellWidth, x)
          items.push(item);
          i++;
        })
        this.rows.push(items)
      })
  }

  private _getSizeItem(columnSize, item) {
    let tamanho = (columnSize - item.length);
    let z = 0;
    let spaces = '';
    while (z < tamanho) {
      spaces = spaces + ' ';
      z++
    }
    return `${item}${spaces}`;
  }
}
